import { useEffect, useState } from "react";
import { FileUp } from "lucide-react";
import api from "@/lib/api";
import { ImportWizard } from "@/components/prospects/ImportWizard";

/* "Bulk upload" button for both dialers: spreadsheet → CRM + dialer campaign (+ admin marks subscriptions). */
export const BulkUpload = ({ admin, onDone, className = "" }) => {
  const [open, setOpen] = useState(false);
  const [ctx, setCtx] = useState({ reps: [], campaigns: [] });
  useEffect(() => {
    if (!open) return;
    Promise.all([api.get("/api/pd/team").catch(() => ({ data: [] })), api.get("/api/callcenter/campaigns/browse").catch(() => ({ data: [] }))])
      .then(([t, c]) => setCtx({ reps: t.data, campaigns: (Array.isArray(c.data) ? c.data : c.data.campaigns || []).filter(x => admin || x.joined) }));
  }, [open, admin]);
  return (
    <>
      <button onClick={() => setOpen(true)} className={`h-8 px-2.5 rounded-lg text-xs font-semibold border border-slate-200 bg-white hover:border-blue-400 flex items-center gap-1.5 ${className}`} data-testid="bulk-upload-btn"><FileUp className="w-3.5 h-3.5" /><span className="hidden sm:inline">Bulk upload</span></button>
      {open && <ImportWizard open dialer admin={admin} reps={ctx.reps} campaigns={ctx.campaigns} onClose={() => setOpen(false)} onDone={(j) => { setOpen(false); onDone?.(j); }} />}
    </>
  );
};
